import { Category } from '../defines/const'

export default class AlgorithmUtil {

  static algorithm2Purpose (categoryId, algorithmId) {
    let purpose = categoryId

    if ([Category.NAVI, Category.DL].indexOf(purpose) >= 0) {
      if ([
        'AutomatedClassifier',
        'WhiteClassifier',
        'BlackClassifier',
        'FNNClf',
        'CNNImageClf'].indexOf(algorithmId) >= 0) {
        purpose = Category.CLF
      } else if ([
        'AutomatedRegressor',
        'WhiteRegressor',
        'BlackRegressor',
        'FNNReg',
        'CNNImageReg'].indexOf(algorithmId) >= 0) {
        purpose = Category.REG
      }
    }

    return purpose
  }
}



// WEBPACK FOOTER //
// ./src/utils/algorithm.js